// extracted by mini-css-extract-plugin
export default {"input":"Payment_input__XKbCA"};